import { PropsWithChildren } from 'react';
import style from './badge.module.scss';
import { KWELLO_ICON, KwelloSvgIcon } from '../../../common/components/icon/KwelloSvgIcon';

interface BadgeProps {
  icon?: KWELLO_ICON;
  borderColor?: string;
  backgroundColor?: string;
  onClose?: any;
  className?: string;
  badgeStyle?: 'positive' | 'negative' | 'neutral' | 'cautious' | 'pending' | 'not-available';
  size?: 'sm' | 'md' | 'lg';
}

export function Badge({
  icon,
  borderColor = '#e3e6ee',
  backgroundColor,
  onClose,
  children,
  className,
  badgeStyle,
  size = 'md',
}: PropsWithChildren<BadgeProps>) {
  return (
    <div
      className={`${style['badge']} ${style[`size-${size}`]} ${onClose ? style['badge-close'] : ''} ${badgeStyle ? style[badgeStyle] : ''} ${className}`}
      style={{ border: `1px solid ${borderColor}`, backgroundColor }}
      onClick={onClose}
    >
      {icon && <KwelloSvgIcon icon={icon} className={style['badge-icon']} />}
      {children}
      {onClose && (
        <span className={style.span}>
          <KwelloSvgIcon icon={KWELLO_ICON.POPUP_CLOSE_ICON} className={style['close-icon']} />
        </span>
      )}
    </div>
  );
}
